import { User } from './types'

let token = localStorage.getItem('jwt')
let user: User | null = token && JSON.parse(atob(token.split('.')[1]))
let adminRoles = ['admin', 'workflowAdmin', 'lead']

function isLoggedIn(): boolean {
    let now = new Date().getTime() / 1000
    return !!user && user.exp > now
}

function checkRole(...roles: Array<string>): boolean {
    let userRoles = user?.role?.split(',') || []
    for (let role of roles) {
        if (userRoles?.includes(role)) return true
    }
    return false
}

function hasAdminAccess(): boolean {
    return checkRole(...adminRoles)
}

function getRole() {
    return user?.role || "user"
}

function setToken(newToken: string) {
    token = newToken
    localStorage.setItem('jwt', newToken)
    user = JSON.parse(atob(token.split('.')[1]))
}

const auth = {
    isLoggedIn,
    checkRole,
    getRole,
    setToken,
    hasAdminAccess,
    logOut() {
        localStorage.clear();
        token = '';
        user = null;
    },
    get user() {
        return user
    },
    get token() {
        return token
    },
}

export default auth